<div class="w-full h-full px-4 lg:px-10 flex flex-col gap-6 pb-2">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col lg:flex-row justify-start lg:justify-between items-start 3xl:hidden">
      <div class="font-semibold text-(--color-text-secondary)!">
        <div
          class="pl-2 font-semibold text-2xl text-(--color-text-primary) flex items-center mb-1 gap-4"
        >
          <button class="button-general w-40" matButton (click)="back()">
            <div class="flex justify-center items-center gap-4">
              <span class="material-symbols-outlined"> reply </span>
              {{ 'common.actions.back' | translate }}
            </div>
          </button>
        </div>
      </div>

      @if (ticketDetail) {
        <app-detail-info-ticket
          class="w-full h-11"
          [ticketDetail]="ticketDetail"
          [center]="center"
        ></app-detail-info-ticket>
      }
    </div>

    <div class="hidden 3xl:flex w-full flex-col gap-4">
      <div class="flex w-full gap-4 flex-col lg:flex-row">
        <div
          class="grid lg:grid-cols-4 grid-cols-2 gap-1 lg:w-[70%] w-full font-semibold text-(--color-text-secondary)! shrink-0!"
        >
          <div
            class="pl-2 font-semibold text-2xl text-(--color-text-primary) col-span-full flex items-center mb-1 gap-4"
          >
            <button class="button-general w-40" matButton (click)="back()">
              <div class="flex justify-center items-center gap-4">
                <span class="material-symbols-outlined"> reply </span>
                {{ 'common.actions.back' | translate }}
              </div>
            </button>
            {{ 'tickets.detail.folio' | translate }} {{ ticketDetail?.TicketNumber || folio }}
          </div>

          <div class="w-full flex flex-col col-span-full gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.sections.connectionPoints' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.Location?.Address || '-' }}
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.customerName' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.Customer || '-' }}
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.status' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.TicketState?.Description || '-' }}
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.connectionType' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.Priority || '-' }}
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.region' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.Region || '-' }}
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.zone' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.Zone || '-' }}
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.site' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.Site || '-' }}
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.workflow' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ ticketDetail?.WorkFlow || '-' }}
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="pl-2 text-sm flex items-center font-medium">
              {{ 'tickets.detail.fields.createdAt' | translate }}
            </div>
            <div class="text-base flex items-center pl-2">
              {{ this.ticketDetailStart?.StartDate || '-' }}
            </div>
          </div>
        </div>

        <div class="w-full h-52 lg:h-auto rounded-[2.5rem] shadow-2xl">
          <google-map height="100%" width="100%" [center]="center" [zoom]="zoom">
            <map-marker [position]="center"></map-marker>
          </google-map>
        </div>
      </div>
    </div>

    <div
      class="flex lg:flex-row flex-col gap-4 h-[calc(100vh-8.75rem)] 3xl:h-[calc(100vh-18.5rem)] pb-2"
    >
      <div
        class="rounded-[2.5rem] shadow-2xl shadow-black/30 inset-shadow-2xs flex justify-between flex-col p-4 h-full w-full lg:p-6"
      >
        <div class="flex flex-col gap-4 h-full">
          <div class="font-medium text-base text-(--color-text-secondary)">
            {{ 'tickets.detail.sections.comments' | translate }}
          </div>
          <div class="flex flex-col gap-4 h-full lg:px-4">
            <div class="flex flex-col gap-4 text-sm h-full scrol-general-y">
              @if (allComentsAndTemplates.length === 0) {
                <div class="flex flex-col gap-2 px-4 text-(--color-text-primary)">
                  <div class="font-semibold">
                    {{ 'tickets.detail.messages.noComments' | translate }}
                  </div>
                </div>
              }
              @for (item of allComentsAndTemplates; track item) {
                @if (item && 'Comment' in item) {
                  <!-- TicketComment -->
                  <div class="flex flex-col gap-2 px-4 text-(--color-text-secondary)">
                    <div class="text-sm font-semibold flex items-center gap-4">
                      <div class="text-(--color-border) shrink-0!">
                        {{ item.CreateDate }}
                      </div>
                      <div class="w-full h-0.5 bg-(--color-border)"></div>
                    </div>
                    <div class="font-semibold whitespace-pre-wrap">{{ item.Comment }}</div>
                    <div class="pl-4 font-medium">
                      {{ item.CommentType + ': Responsable: ' + item.Responsible }}
                    </div>
                  </div>
                } @else if (item && 'Template' in item) {
                  <!-- TicketTemplate -->
                  <div class="flex flex-col gap-2 px-4 text-(--color-text-secondary)">
                    <div class="text-sm font-semibold flex items-center gap-4">
                      <div [style]="`color: ${item.Color}`" class="t) shrink-0!">
                        {{ item.CreateDate }}
                      </div>

                      <div [style]="`background-color: ${item.Color} `" class="w-full h-0.5"></div>
                    </div>
                    <div class="whitespace-pre-wrap" [innerHTML]="item.Content"></div>
                    <!-- <div class="font-semibold">-</div> -->
                    <div class="pl-4 font-medium">
                      {{ 'tickets.detail.labels.template' | translate }}: {{ item.User || '-' }}
                    </div>
                  </div>
                }
              }
            </div>

            <div
              class="flex lg:flex-row lg:justify-between justify-center flex-col items-end gap-4 border-t border-(--color-text-secondary) py-4"
            >
              <app-input-general-text
                class="w-full"
                [formControlGeneral]="controlComment"
                [label]="'tickets.detail.labels.addComment'"
                [placeholder]="'tickets.detail.labels.addComment'"
              ></app-input-general-text>

              <div class="h-full flex items-end justify-center m-auto">
                <button
                  [disabled]="controlComment.invalid"
                  class="button-general-border px-6! mb-5 h-12! lg:w-auto w-52"
                  (click)="createTicketTemplate()"
                  matButton
                  type="submit"
                >
                  <div class="flex justify-center items-center gap-4">
                    <mat-icon>send</mat-icon>
                    <div>{{ 'common.actions.send' | translate }}</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="rounded-[2.5rem] shadow-2xl shadow-black/30 inset-shadow-2xs flex justify-between flex-col p-4 h-full w-full lg:p-6"
      >
        <div class="flex flex-col gap-4 h-full">
          <div class="font-medium text-base text-(--color-text-secondary)">
            {{ 'tickets.detail.sections.attachments' | translate }}
          </div>
          <div class="flex flex-col gap-4 text-sm h-full scrol-general-y">
            @for (doc of allAttachments; track doc) {
              <div class="flex flex-col gap-2 text-(--color-text-primary) lg:px-4">
                <div class="font-semibold flex flex-col justify-center gap-4">
                  <div class="text-sm font-semibold flex items-center gap-4">
                    <div class="text-(--color-border) shrink-0!">
                      {{ 'tickets.detail.labels.document' | translate }} {{ doc.UploadDate }}
                    </div>
                    <div class="w-full h-0.5 bg-(--color-border)"></div>
                  </div>
                  <div class="px-4 flex items-start gap-4">
                    @if (isImageByFileName(doc.FileName)) {
                      <!-- IMAGEN -->
                      @if (doc.file) {
                        <img
                          class="w-40 rounded-2xl"
                          [src]="doc.file"
                          [attr.alt]="'common.accessibility.attachedImage' | translate"
                        />
                      }
                    } @else if (isPdfByFileName(doc.FileName)) {
                      <!-- PDF -->
                      <img
                        class="w-30 rounded-2xl"
                        src="../../../assets/icons/icon_pdf.svg"
                        [attr.alt]="'common.accessibility.pdfFile' | translate"
                      />
                    } @else if (isVideoByFileName(doc.FileName)) {
                      <!-- VIDEO -->
                      <img
                        class="w-30 rounded-2xl"
                        src="../../../assets/icons/icon_play.svg"
                        [attr.alt]="'common.accessibility.videoFile' | translate"
                      />
                    } @else {
                      <!-- OTROS -->
                      <img
                        class="w-30 rounded-2xl"
                        src="../../../assets/img/icon_archivo.svg"
                        [attr.alt]="'common.accessibility.genericFile' | translate"
                      />
                    }

                    <div class="flex flex-col gap-4">
                      <div class="font-medium">
                        {{ doc.FileName }}
                      </div>
                      <div class="flex gap-2">
                        <button
                          class="button-alternative mb-4 w-40"
                          (click)="downloadFile(doc.DownloadUrl)"
                          matButton
                        >
                          <div class="flex justify-center items-center gap-4">
                            <span class="material-symbols-outlined"> download </span>
                            {{ 'common.actions.download' | translate }}
                          </div>
                        </button>

                        <button
                          class="button-alternative rounded-full! mb-4"
                          matMiniFab
                          (click)="viewFileLight(doc.DownloadUrl)"
                        >
                          <div class="flex justify-center items-center gap-4">
                            <span class="material-symbols-outlined"> visibility </span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (isFallasWorkFlow) {
              <div class="font-semibold flex flex-col justify-center gap-4">
                <div class="text-sm font-semibold flex items-center gap-4">
                  <div class="text-(--color-border) shrink-0!">
                    {{ 'tickets.detail.labels.document' | translate }}
                  </div>
                  <div class="w-full h-0.5 bg-(--color-border)"></div>
                </div>
                <div class="px-4 flex items-start gap-4">
                  <img
                    class="w-40 rounded-2xl"
                    src="../../../assets/img/Guía.jpg"
                    [attr.alt]="'common.accessibility.attachedImage' | translate"
                  />
                  <div class="flex flex-col gap-4">
                    <div class="font-medium text-sm text-(--RJ-text-gray)">
                      {{ 'tickets.detail.labels.upsGuideFile' | translate }}
                    </div>
                    <button class="button-alternative mb-4 w-40" matButton>
                      <div
                        class="flex justify-center items-center gap-4"
                        (click)="downloadFileUPS('../../../assets/pdfs/Guía de UPS.pdf')"
                      >
                        <span class="material-symbols-outlined"> download </span>
                        {{ 'common.actions.download' | translate }}
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="flex justify-end gap-4 border-t border-(--color-text-secondary) py-4">
            <button class="button-alternative w-40" matButton (click)="triggerFileInput()">
              <div class="flex justify-center items-center gap-4">
                <span class="material-symbols-outlined"> backup </span>
                {{ 'common.actions.attach' | translate }}
              </div>
            </button>
            <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (loadService) {
    <app-load-general [load]="loadService"></app-load-general>
  }
</div>
